/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.5 10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10M9.5 10C9.5 9.72386 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.72386 8.5 10M9.5 10H8.5M15.5 10C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10M15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10M15.5 10H14.5M16.0002 15C15.088 16.2144 13.6357 17 11.9999 17C10.3641 17 8.91172 16.2144 7.99951 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="10"
				fill="currentColor"
			/>
			<path
				d="M9.5 10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10M9.5 10C9.5 9.72386 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.72386 8.5 10M9.5 10H8.5M15.5 10C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10M15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10M15.5 10H14.5M16.0002 15C15.088 16.2144 13.6357 17 11.9999 17C10.3641 17 8.91172 16.2144 7.99951 15M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM8.99998 8.74998C8.30963 8.74998 7.74998 9.30963 7.74998 9.99998C7.74998 10.6903 8.30963 11.25 8.99998 11.25C9.69034 11.25 10.25 10.6903 10.25 9.99998C10.25 9.30963 9.69034 8.74998 8.99998 8.74998ZM15 8.74998C14.3096 8.74998 13.75 9.30963 13.75 9.99998C13.75 10.6903 14.3096 11.25 15 11.25C15.6903 11.25 16.25 10.6903 16.25 9.99998C16.25 9.30963 15.6903 8.74998 15 8.74998ZM8.59917 14.5495C8.3504 14.2184 7.88025 14.1515 7.54906 14.4003C7.21787 14.6491 7.15105 15.1192 7.39982 15.4504C8.44759 16.8453 10.1182 17.75 11.9999 17.75C13.8815 17.75 15.5521 16.8453 16.5999 15.4504C16.8487 15.1192 16.7819 14.6491 16.4507 14.4003C16.1195 14.1515 15.6493 14.2184 15.4006 14.5495C14.6239 15.5835 13.3898 16.25 11.9999 16.25C10.6099 16.25 9.37581 15.5835 8.59917 14.5495Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10M9.5 10C9.5 9.72386 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.72386 8.5 10M9.5 10H8.5M15.5 10C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10M15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10M15.5 10H14.5M16.0002 15C15.088 16.2144 13.6357 17 11.9999 17C10.3641 17 8.91172 16.2144 7.99951 15M17 3.33782C15.5291 2.48697 13.8214 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.96818 21.394 8.0779 20.353 6.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9.5 10C9.5 10.2761 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.2761 8.5 10M9.5 10C9.5 9.72386 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.72386 8.5 10M9.5 10H8.5M15.5 10C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 10M15.5 10C15.5 9.72386 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.72386 14.5 10M15.5 10H14.5M16.0002 15C15.088 16.2144 13.6357 17 11.9999 17C10.3641 17 8.91172 16.2144 7.99951 15M12 22V22C17.5228 22 22 17.5228 22 12V12C22 6.47715 17.5228 2 12 2V2C6.47715 2 2 6.47715 2 12V12C2 17.5228 6.47715 22 12 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.75004 10C7.75004 9.30964 8.30969 8.75 9.00004 8.75C9.6904 8.75 10.25 9.30964 10.25 10C10.25 10.6904 9.6904 11.25 9.00004 11.25C8.30969 11.25 7.75004 10.6904 7.75004 10ZM13.75 10C13.75 9.30964 14.3097 8.75 15 8.75C15.6904 8.75 16.25 9.30964 16.25 10C16.25 10.6904 15.6904 11.25 15 11.25C14.3097 11.25 13.75 10.6904 13.75 10ZM7.54912 14.4003C7.88031 14.1516 8.35046 14.2184 8.59923 14.5496C9.37588 15.5835 10.61 16.25 11.9999 16.25C13.3899 16.25 14.624 15.5835 15.4006 14.5496C15.6494 14.2184 16.1195 14.1516 16.4507 14.4003C16.7819 14.6491 16.8487 15.1192 16.6 15.4504C15.5522 16.8454 13.8816 17.75 11.9999 17.75C10.1182 17.75 8.44765 16.8454 7.39988 15.4504C7.15111 15.1192 7.21793 14.6491 7.54912 14.4003Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
